import { useState } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '关于亲亲', href: '#about' },
  { label: '热门排行', href: '#ranking' },
  { label: '联系我们', href: '#contact' },
  { label: '精彩视频', href: '#media' },
  { label: '热门话题', href: '#topics' },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-[72px] flex items-center bg-background-50/95 backdrop-blur-sm transition-shadow duration-300" style={{ boxShadow: '0 1px 0 oklch(var(--background-200))' }}>
      <nav className="w-full max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-full">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
          className="flex items-center gap-2 text-foreground-950 no-underline"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-lg text-background-50"></i>
          </div>
          <span className="font-heading text-xl font-bold whitespace-nowrap">亲亲漫画网</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden absolute top-[72px] left-0 right-0 bg-background-50 border-t border-background-200 shadow-lg">
          <div className="flex flex-col p-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap no-underline cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}